import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import FileUpload from "../../../Components/common/FileUpload/FileUpload";
import FileCardButton from "../../../Components/UI/FileCardButton/FileCardButton";
import Backdrop from "../../../Components/UI/Backdrop/Backdrop";

import WebIcon from "../../../Components/Icon-SVG/WebIcon";

import { addNotification } from "../../../store/actions/notifierActions";
import { RequestWatermarkUpload } from "../../../store/actions/watermarkDecoderActions";

const UploadCard = () => {
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.watermarkDecoder.uploadLoading);

  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (!file) {
      setPreviewUrl(null);
      return;
    }
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const onFileError = (errMessage) => {
    if (!errMessage) return;
    dispatch(
      addNotification({
        message: errMessage,
        options: { variant: "error" },
      }),
    );
  };

  const submitHandler = () => {
    if (!file) {
      dispatch(
        addNotification({
          message: "Please select a PNG or JPG file.",
          options: { variant: "error" },
        }),
      );
      return;
    }
    dispatch(RequestWatermarkUpload({ file }));
  };

  return (
    <div className="watermark-decoder__upload-section">
      <div className="watermark-decoder__upload-card border">
        <div className="watermark-decoder__upload-card__wrapper">
          <h2>Upload Image</h2>

          <FileUpload
            file={file}
            setFile={setFile}
            setFileError={onFileError}
            allowedExtensions={["png", "jpg", "jpeg"]}
            errorMessage="Please select a PNG or JPG file."
            styles={{ formWidth: "100%", infoTextWidth: "180px", infoTextPadding: "0" }}
          />

          <FileCardButton onClick={submitHandler}>
            <WebIcon width={21} height={21} color="white" />
            <p>Analyze</p>
          </FileCardButton>
        </div>
      </div>

      <div className="watermark-decoder__preview-card border">
        <h2>Image Preview</h2>

        {previewUrl ? (
          <div className="watermark-decoder__preview-card__image">
            <img src={previewUrl} alt="Selected preview" />
          </div>
        ) : (
          <div className="watermark-decoder__preview-card__info">
            <p className="watermark-decoder__help-text">
              Select a PNG or JPG image to preview it here before running the analysis.
            </p>
            <p className="watermark-decoder__preview-card__info-title">During analysis we will for your forensic purposes:</p>
            <ul className="watermark-decoder__preview-card__list">
              <li>Deblur and enhance the image to improve readability.</li>
              <li>Generate multiple enhanced variants for inspection.</li>
              <li>Run OCR to detect embedded watermark strings.</li>
              <li>Decode and decrypt any detected watermark data.</li>
            </ul>
          </div>
        )}
      </div>

      <Backdrop show={loading} message="Processing image, please wait..." />
    </div>
  );
};

export default UploadCard;
